import Fingerprint from 'fingerprintjs2';
import Fingerprint2V2 from 'fingerprintjs2-v2';
import Cookies from 'js-cookie';
import UAParser from 'ua-parser-js';
import sha256 from 'js-sha256';
import {userFingerprintV1Cookie, userFingerprintV2Cookie} from '../analytics/AnalyticsConst';
import CheckIpApi from '../api/CheckIpApi';
import {captureException} from '../utils/SentryUtils';

let cachedIpAddress = null;

const fingerprintBuilder = new Fingerprint();
let cachedFingerprint = null;

let cachedFingerprintV2 = null;

export function getFingerprintV1(cb) {
  const cookieFingerprint = Cookies.get(userFingerprintV1Cookie);
  if (cookieFingerprint) {
    cachedFingerprint = cookieFingerprint;
    if (cb) {
      cb(cookieFingerprint);
    }
  } else {
    fingerprintBuilder.get((fingerprint) => {
      cachedFingerprint = fingerprint;
      Cookies.set(userFingerprintV1Cookie, fingerprint);
      if (cb) {
        cb(fingerprint);
      }
    });
  }
}

export function getCachedFingerprintV1() {
  return cachedFingerprint;
}

export function getCachedFingerprintV2() {
  return cachedFingerprintV2;
}


export function getFingerprintV2(cb) {
  const cookieFingerprint = Cookies.get(userFingerprintV2Cookie);
  if (cookieFingerprint) {
    cachedFingerprintV2 = cookieFingerprint;
    if (cb) cb(cookieFingerprint);
  } else {
    const handleGet = (components) => {
      const values = components.map(component => component.value);
      const fingerprint = sha256(values.join(''));
      cachedFingerprintV2 = fingerprint;
      Cookies.set(userFingerprintV2Cookie, fingerprint);
      if (cb) cb(fingerprint);
    };

    if (window.requestIdleCallback) {
      requestIdleCallback(() => {
        Fingerprint2V2.get(fingerprintV2Options(), handleGet);
      });
    } else {
      setTimeout(() => {
        Fingerprint2V2.get(fingerprintV2Options(), handleGet);
      }, 500);
    }
  }
}

function fingerprintV2Options() {
  return {
    extraComponents: [
      {
        key: 'ipAddress',
getData: async (done) => {
          const ip = await getIp();
          done(ip);
        }
      },
    ],
    preprocessor: fingerprint2Preprocessor
  };
}

  async function getIp() {
    if (cachedIpAddress) {
      return cachedIpAddress;
    }

    try {
      cachedIpAddress = await CheckIpApi.check();
      return cachedIpAddress;
    } catch (e) {
      captureException(e);
      return null;
    }
  }

  function fingerprint2Preprocessor(key, value) {
    if (key === 'userAgent') {
      const parser = new UAParser(value);
      return parser.getOS().name + ' ' + parser.getBrowser().name;
    }
    return value;
  }

// gets fingerprints of both versions
  export function getFingerprints(cb) {
    getFingerprintV1((fingerprint) => {
      getFingerprintV2((fingerprint2) => {
        if (cb) cb({fingerprint, fingerprint2});
      });
    });
  }
